import React from 'react';

function EPDesignTemplates() {
  return (
    <div>EPDesignTemplates</div>
  );
}

export default EPDesignTemplates;
